"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BlockIcon = function BlockIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "99",
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 41.3851C20 57.614 33.4295 70.7701 49.9956 70.7701C52.0704 70.7701 54.0961 70.5638 56.0523 70.1708L79.9122 43.5343C79.9645 42.8246 79.9912 42.1079 79.9912 41.3851C79.9912 25.1561 66.5617 12 49.9956 12C33.4295 12 20 25.1561 20 41.3851Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50 49.9999C54.411 49.9999 58 46.4109 58 41.9999C58 38.6499 55.928 35.7789 53 34.5889V36.8119C54.79 37.8519 56 39.7849 56 41.9999C56 45.3089 53.309 47.9999 50 47.9999C46.691 47.9999 44 45.3089 44 41.9999C44 39.7849 45.21 37.8509 47 36.8119V34.5889C44.072 35.7789 42 38.6499 42 41.9999C42 46.4109 45.589 49.9999 50 49.9999Z",
    fill: "#D13939"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.7998 33.8001C48.7998 33.1374 49.3371 32.6001 49.9998 32.6001C50.6625 32.6001 51.1998 33.1374 51.1998 33.8001V38.6001C51.1998 39.2628 50.6625 39.8001 49.9998 39.8001C49.3371 39.8001 48.7998 39.2628 48.7998 38.6001V33.8001Z",
    fill: "#D13939"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.2868 69.9589L79.7471 43.784C79.848 43.6715 79.7975 43.4974 79.6491 43.4703C77.9918 43.1681 70.1968 42.1809 63.0036 48.6212C55.7601 55.1066 55.8492 67.3323 55.9493 69.8489C55.9563 70.0249 56.169 70.0903 56.2868 69.9589Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "99.9912",
    height: "98.7701",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dy: "8"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886719 0 0 0 0 0.903646 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "67.3941",
    y1: "56.8284",
    x2: "58.5502",
    y2: "48.0839",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#D9DEE8"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#FDFDFD"
  }))));
};

var _default = BlockIcon;
exports.default = _default;